import gql from 'graphql-tag';

export const WEIGHTED_AVERAGE_BOND = gql`
    query WeightedAverageBond($ticker: String!) {
        fund: mutualFund(ticker: $ticker) {
            trpCode
            weightedAverageDurationDate
            weightedAverageEffectiveDuration
            weightedAverageMaturity
            weightedAverageMaturityDate
        }
    }
`;

export const WEIGHTED_AVERAGE_MM = gql`
    query WeightedAverageMM($ticker: String!) {
        mutualFund(ticker: $ticker) {
            trpCode
            benchmarkPerformanceDetail {
                weightedAverageMaturityDays
                weightedAverageMaturityDaysAsOfDate
                weightedAverageLifeAsOfDate
                weightedAverageLife
            }
        }
    }
`;

export const WEIGHTED_AVERAGE_ETF = gql`
    query WeightedAverageFund($ticker: String!) {
        fund: exchangeTradedFund(ticker: $ticker) {
            trpCode
            portfolioCharacteristics {
                asOfDate
                fundPortfolioCharacteristic {
                    weightedAverageMaturity
                    weightedAverageEffectiveDuration
                }
            }
        }
    }
`;
